export enum UserPreferenceChannelEnum {
  PUSH = 'push',
  EMAIL = 'email',
  SMS = 'sms',
}

export enum HermesNotificationTemplates {
  shiftCreationDetailed = 'shiftCreationDetailed',
  shiftCreationGeneric = 'shiftCreationGeneric',
  poolOfferCreationDetailed = 'poolOfferCreationDetailed',
}
